import React from 'react';
import clsx from 'clsx';

import Typography from '@material-ui/core/Typography';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Grid from '@material-ui/core/Grid';

import Title from '../../components/Title/Title';

import useStyles from './Style';

const Anexo3 = () => {
    const classes = useStyles();
    return (
        <>
            <Title id="anchor-a3" className={classes.title}>
                ANEXO III – Premiação
            </Title>

            <Typography className={classes.text} variant="body2">
                A premiação dos professores será distribuída seguindo as categorias e as quantidades dispostas no quadro abaixo:
                <br /><br />

                <Grid 
                    container 
                    align='center' 
                    direction="row" 
                    justify="center"
                    alignItems="center"
                    className={classes.wrapper}
                >
                    <Grid item sm={6} lg={6}>
                        <TableContainer component="div">
                            <Table size="small">
                                <TableHead>
                                    <TableRow>
                                        <TableCell align="center" className={clsx(classes.bolder, classes.backGray)} width="25%">Premiação</TableCell>
                                        <TableCell align="center" className={clsx(classes.bolder, classes.backGray)} width="25%">Total</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    <TableRow style={{ border: 1 }}>
                                        <TableCell align="center" className={classes.bolder} style={{ backgroundColor: '#B68D4A', color: '#FFFFFF' }}>Medalha de OURO</TableCell>
                                        <TableCell align="center" className={classes.bolder}>25</TableCell>
                                    </TableRow>
                                    <TableRow style={{ border: 1 }}>
                                        <TableCell align="center" className={classes.bolder} style={{ backgroundColor: '#A3A2A0', color: '#FFFFFF' }}>Medalha de PRATA</TableCell>
                                        <TableCell align="center" className={classes.bolder}>50</TableCell>
                                    </TableRow>
                                    <TableRow style={{ border: 1 }}>
                                        <TableCell align="center" className={classes.bolder} style={{ backgroundColor: '#A46628', color: '#FFFFFF' }}>Medalha de BRONZE</TableCell>
                                        <TableCell align="center" className={classes.bolder}>100</TableCell>
                                    </TableRow>
                                    <TableRow style={{ border: 1 }}>
                                        <TableCell align="center" className={clsx(classes.bolder, classes.lightGray)}>Menção Honrosa</TableCell>
                                        <TableCell align="center" className={classes.bolder}>500</TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Grid>
                </Grid>
            </Typography>

            <Typography className={classes.text} variant="body2">
                O professor premiado com <span className={classes.bolder}>Menção Honrosa</span> será condecorado com Certificado Digital.
            </Typography>

            <Typography className={classes.text} variant="body2">
                O professor premiado com <span className={classes.bolder}>Medalha</span> será condecorado com os prêmios, a saber, a depender do tipo de medalha conquistada <span className={classes.bolder}>(ouro, prata ou bronze)</span>:
                <br /><br />

               <Grid 
                    container 
                    align='center' 
                    direction="row" 
                    justify="center"
                    alignItems="center"
                    className={classes.wrapper}
                >
                    <Grid item sm={10} lg={10}>
                        <TableContainer component="div">
                            <Table size="small">
                                <TableHead>
                                    <TableRow>
                                        <TableCell align="center" className={clsx(classes.bolder, classes.backGray)} width="40%">Prêmio</TableCell>
                                        <TableCell align="center" className={classes.bolder} style={{ backgroundColor: '#B68D4A', color: '#FFFFFF' }} width="20%">Ouro</TableCell>
                                        <TableCell align="center" className={classes.bolder} style={{ backgroundColor: '#A3A2A0', color: '#FFFFFF' }} width="20%">Prata</TableCell>
                                        <TableCell align="center" className={classes.bolder} style={{ backgroundColor: '#A46628', color: '#FFFFFF' }} width="20%">Bronze</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    <TableRow style={{ border: 1 }}>
                                        <TableCell align="center" className={clsx(classes.bolder, classes.lightGray)}>Medalha</TableCell>
                                        <TableCell align="center">Sim</TableCell>
                                        <TableCell align="center">Sim</TableCell>
                                        <TableCell align="center">Sim</TableCell>
                                    </TableRow>
                                    <TableRow style={{ border: 1 }}>
                                        <TableCell align="center" className={clsx(classes.bolder, classes.lightGray)}>Certificado Digital</TableCell>
                                        <TableCell align="center">Sim</TableCell>
                                        <TableCell align="center">Sim</TableCell>
                                        <TableCell align="center">Sim</TableCell>
                                    </TableRow>
                                    <TableRow style={{ border: 1 }}>
                                        <TableCell align="center" className={clsx(classes.bolder, classes.lightGray)}>
                                            Participação no Curso Digital de Formação em Matemática para Professores do Ensino Fundamental I
                                        </TableCell>
                                        <TableCell align="center">Sim</TableCell>
                                        <TableCell align="center">Sim</TableCell>
                                        <TableCell align="center">Sim</TableCell>
                                    </TableRow>
                                    <TableRow style={{ border: 1 }}>
                                        <TableCell align="center" className={clsx(classes.bolder, classes.lightGray)}>Kit pedagógico</TableCell>
                                        <TableCell align="center">Não</TableCell>
                                        <TableCell align="center">Sim</TableCell>
                                        <TableCell align="center">Não</TableCell>
                                    </TableRow>
                                    <TableRow style={{ border: 1 }}>
                                        <TableCell align="center" className={clsx(classes.bolder, classes.lightGray)}>
                                            Participação presencial de parte das aulas do Curso Digital de Formação em Matemática para Professores do Ensino Fundamental I
                                        </TableCell>
                                        <TableCell align="center">Sim</TableCell>
                                        <TableCell align="center">Não</TableCell>
                                        <TableCell align="center">Não</TableCell>
                                    </TableRow>
                                    <TableRow style={{ border: 1 }}>
                                        <TableCell align="center" className={clsx(classes.bolder, classes.lightGray)}>
                                            Participação na Cerimônia Nacional de Premiação dos Medalhistas de Ouro da OBMEP
                                        </TableCell>
                                        <TableCell align="center">Sim</TableCell>
                                        <TableCell align="center">Não</TableCell>
                                        <TableCell align="center">Não</TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Grid>
                </Grid>
            </Typography>
        </>
    )
}

export default Anexo3;